import { render, staticRenderFns } from "./Censimento.vue?vue&type=template&id=632923d3&"
import script from "./Censimento.vue?vue&type=script&lang=js&"
export * from "./Censimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports